module.exports = __webpack_public_path__ + "media/images/ui-bg_glass_25_e1f0f5_1x400-b1c7831c2298fd912c2b538df07e644c.png";